<loading-bar *ngIf="loading"></loading-bar>

<h4 *ngIf="!loading && !registration">No registration found for the given asset</h4>

<div *ngIf="registration" class="details-section">
  <div class="section-header">Details</div>
  <div class="section-tab">
    <div class="row">
      <div class="col1">Registration ID:</div>
      <div class="col">{{ registration.id }}</div>
    </div>
    <!-- <div class="row">
      <div class="col1" matTooltip="ServIs asset ID">ABB Asset ID:</div>
      <div class="col"><asset-link [assetId]="registration.abbAssetId" /></div>
    </div> -->
    <div class="row">
      <div class="col1">Commissioning Date:</div>
      <div class="col">{{ registration.commissioningDate | date }}</div>
    </div>
    <div class="row">
      <div class="col1" matTooltip="Asset name in customer process">Customer Asset Name:</div>
      <div class="col">{{ registration.customerAssetName }}</div>
    </div>
    <div class="row">
      <div class="col1">Asset Status:</div>
      <div class="col">{{ registration.assetStatus }}</div>
    </div>
    <div class="row">
      <div class="col1">Certified Startup:</div>
      <div class="col">{{ registration.certifiedStartup ? 'Yes' : 'No' }}</div>
    </div>
    <div class="row">
      <div class="col1">Application:</div>
      <div class="col">{{ registration.application }}</div>
    </div>
  </div>
</div>

<div *ngIf="registration"  class="details-section">
  <!--<div class="section-header">Customer</div>
  <div class="section-tab"> -->
    <customer-registration-details *ngIf="registration" [customerId]="registration.customerId" />
  <!-- </div>-->
</div>

<div *ngIf="registration"  class="details-section">
  <div class="section-header">Site</div>
  <div class="section-tab">
    <site-details [siteId]="registration.siteId"></site-details>
  </div>
</div>

<div *ngIf="registration"  class="details-section">
  <div class="section-header">Location</div>
  <div class="section-tab">
    <location-tree [location]="registration.location"></location-tree>
  </div>
</div>
